import React from 'react';
import ClassNames from 'classnames';
import StylePropable from 'mixins/js/StylePropable';
import Colors from 'mixins/js/colors';
import Transitions from 'utils/transitions';


export default React.createClass({

	propTypes: {
		position: React.PropTypes.string,
		left: React.PropTypes.number,
		width: React.PropTypes.number
	},
	
	mixins: [StylePropable],

	getInitialState(){
		return {
			width: this.props.width,
			left: this.props.left
		}
	},

	render() {

		let styles = this.mergeAndPrefix({
			left: this.state.left,
			width: this.state.width,
		});

		let classes = ClassNames( 'lui-ink-bar', this.props.className )

		return (
			<div style={styles} className={classes}>
				&nbsp;
			</div>
		);
	},

	setWidth(width) {
		this.setState({
			width: width
		});
	},	

	setLeft(left) {
		this.setState({
			left: left
		});
	},
});


/** WEBPACK FOOTER **
 ** ./src/components/ink-bar/InkBar.js
 **/